export interface Defer<T> {
	promise: Promise<T> | null;
	resolve: (value?: any) => void;
	reject: (err?: any) => void;
	isResolved: boolean;
	then?: any;
	[key: string]: any;
}

export function createDefer<T>(): Defer<T> {
	const rv: Defer<T> = {
		promise: null,
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		resolve: () => {},
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		reject: () => {},
		isResolved: false,
		then(this: Defer<T>, cb: any) {
			const { promise } = this;
			// return promise && promise.then(cb);
			return (promise as Promise<T>).then(cb);
		}
	};
	rv.promise = new Promise<T>((resolve, reject) => {
		rv.resolve = (value?: any) => {
			rv.isResolved = true;
			resolve(value);
		};
		rv.reject = (err?: any) => {
			rv.isResolved = true;
			reject(err);
		};
	});
	return rv;
}
